import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '@mona/api';
import { QuestionnaireGroup } from '@mona/models';
import { ApiQuestionnaireGroup, transformApiQuestionnaireGroups } from './transforms';

/**
 * API abstraction layer for configurable questionnaires
 */
@Injectable({
    providedIn: 'root',
})
export class ConfigurableQuestionnairesApi {
    /**
     * Constructor
     * @param http HttpService
     */
    constructor(private http: HttpService) {}

    /**
     * Load questionnaire groups list
     * @returns Observable<QuestionnaireGroup[]>
     */
    loadQuestionnaireGroups(): Observable<QuestionnaireGroup[]> {
        return this.http
            .get<ApiQuestionnaireGroup[] | { results?: ApiQuestionnaireGroup[] }>('/questionnaire/questionnaire-groups')
            .pipe(
                map(results => {
                    const groups = Array.isArray(results) ? results : (results?.results ?? []);
                    return transformApiQuestionnaireGroups(groups);
                }),
            );
    }
}
